import Component from '@glimmer/component'
import { action } from '@ember/object'
import { service } from '@ember/service'
import type AnalyticsService from 'teacher-ui-client/services/analytics'
import type TeacherEvents from 'teacher-ui-client/services/teacher-events'
import type { SubscriptionTypeService } from 'teacher-ui-client/services/subscription-type'
import { sendPdfDownloadEvent } from 'teacher-ui-client/modifiers/pdf-download-event'
import UiButton from 'teacher-ui-client/components/ui-button'
import { fullGradeName } from 'teacher-ui-client/helpers/full-grade-name'
import { on } from '@ember/modifier'
import { t } from 'ember-intl'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'

interface Signature {
  Element: HTMLDivElement
  Args: {
    fileUrl: string
    title: string
    coverUrl: string
    gradePosition: number
    description?: string
  }
}

export class CatchUpGuideTile extends Component<Signature> {
  @service analytics!: AnalyticsService

  @service teacherEvents!: TeacherEvents

  @service subscriptionType!: SubscriptionTypeService

  @action
  downloadPdf() {
    const { fileUrl, title } = this.args

    if (fileUrl) {
      const splitFileUrl = fileUrl.split('/')
      const file = splitFileUrl[splitFileUrl.length - 1]

      sendPdfDownloadEvent(
        { analytics: this.analytics, teacherEvents: this.teacherEvents, subscriptionType: this.subscriptionType },
        {
          category: 'Catch Up Guide',
          label: title,
          file,
        },
      )
    }

    window.open(fileUrl)
  }

  <template>
    <div class="sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/4 2xl:w-1/5" ...attributes>
      <div class="mx-6 mt-6 block rounded-b-md border-2 px-6 py-6">
        <img
          src="{{@coverUrl}}?h=250"
          class="border-dusty-black-100 mx-auto block w-1/2 rounded-md border border-solid p-1 shadow-xs"
          alt="{{@title}}"
        />
        <div class="pt-3 text-center">
          {{fullGradeName @gradePosition}}
        </div>
        <h5 class="mt-4 mb-4 text-center">
          {{@title}}
        </h5>
        <div class="mb-4 text-center">
          {{@description}}
        </div>
        <div class="text-center">
          <UiButton @appearance={{ButtonAppearance.regular}} {{on "click" this.downloadPdf}}>
            {{t "download"}}
          </UiButton>
        </div>
      </div>
    </div>
  </template>
}

export default CatchUpGuideTile
